module.exports = __webpack_public_path__ + "static/img/a6.960395d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/founderIntr/img/en/a6.png
// module id = VQ4q
// module chunks = 5